// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (eventId: string) => axios.get(`/events/${eventId}/saves`);

export type LoadTempSavePayload = {
  eventId: string,
  saveId: string,
};

export const loadTempSave = ({ eventId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/events/${eventId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/events/saves.js